module.exports = __webpack_public_path__ + "static/media/valid_recipients_icon.300ccd49.png";